import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import themeConfig from '../config/theme.config';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

const ThemeProviders = ({ children }: { children: React.ReactNode }) => {
    const lang = useSelector((state: RootState) => state.lang.language);

    const theme = createTheme(themeConfig(lang));

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
};

export default ThemeProviders;
